import {
  Button,
  Header,
  SpaceBetween,
  Table,
} from '@cloudscape-design/components';
import LotDisplay from 'features/lots/components/LotDisplay';
import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';

/** The Activity log table on the lot detail page. */
export default function LotEventsTable({ events, loading = false }) {
  const navigate = useNavigate();

  const columnDefinitions = [
    {
      id: 'timestamp',
      header: 'Time',
      // eslint-disable-next-line no-underscore-dangle
      cell: (item) => item._createdBy?.timestamp?.toDate?.().toLocaleString() || '—',
    },
    {
      id: 'type',
      header: 'Event',
      cell: (item) => item.type,
    },
    {
      id: 'deltaQty',
      header: 'Δ Qty',
      cell: (item) => {
        if (typeof item.deltaQty !== 'number') return '—';
        return item.deltaQty > 0 ? `+${item.deltaQty}` : `${item.deltaQty}`;
      },
    },
    {
      id: 'reason',
      header: 'Reason',
      cell: (item) => item.reason || '—',
    },
    {
      id: 'related',
      header: 'Related',
      // eslint-disable-next-line react/no-unstable-nested-components
      cell: (item) => {
        const { travelerId, lotId } = item.relatedIds || {};
        if (!travelerId && !lotId) return '—';
        return (
          <SpaceBetween direction="horizontal" size="xs">
            {lotId && <LotDisplay lotId={lotId} link />}
            {travelerId && (
              <Button variant="inline-link" onClick={() => navigate(`/travelers/${travelerId}`)}>
                {travelerId}
              </Button>
            )}
          </SpaceBetween>
        );
      },
    },
    {
      id: 'by',
      header: 'By',
      // eslint-disable-next-line no-underscore-dangle
      cell: (item) => item._createdBy?.email || '—',
    },
  ];

  return (
    <Table
      header={<Header variant="h2">Activity</Header>}
      items={events}
      columnDefinitions={columnDefinitions}
      loading={loading}
      wrapLines
      empty={<div>No activity</div>}
    />
  );
}

LotEventsTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  events: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool,
};
